/**
 * MifeLife — Maintenance / under-construction page.
 *
 * Rendered for every route when REACT_APP_MAINTENANCE_MODE is "true".
 * Owner bypass: append `?bypass=<value of REACT_APP_MAINTENANCE_BYPASS>` to
 * any URL once — the value is cached in localStorage so subsequent visits
 * skip the gate from the same browser.
 */
import React from 'react';
import { Sparkles, Mail } from 'lucide-react';

export default function MaintenancePage() {
  return (
    <div className="min-h-screen bg-[#0F0F1A] text-white antialiased flex items-center justify-center px-6" data-testid="maintenance-page">
      <div className="absolute inset-0 pointer-events-none overflow-hidden">
        <div className="absolute top-1/3 left-1/2 -translate-x-1/2 w-[600px] h-[400px] rounded-full bg-violet-500/[0.08] blur-[120px]" />
      </div>
      <div className="relative max-w-xl text-center">
        <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-violet-500/10 border border-violet-400/30 text-[11px] uppercase tracking-[0.18em] text-violet-200 mb-7">
          <Sparkles className="w-3 h-3" /> MIFELIFE
        </div>
        <h1 className="text-4xl sm:text-5xl font-semibold tracking-tight leading-[1.05]">
          Kısa bir{' '}
          <span className="bg-gradient-to-r from-violet-300 to-cyan-300 bg-clip-text text-transparent">bakım molası</span>{' '}
          veriyoruz.
        </h1>
        <p className="mt-5 text-base text-slate-400 leading-relaxed">
          Platformu daha iyi bir deneyim için geliştiriyoruz. Çok kısa süre içinde yeniden açıyoruz.
        </p>
        <p className="mt-3 text-sm text-slate-500 leading-relaxed">
          We're polishing the platform. Back online very soon.<br />
          Wir verbessern die Plattform. Wir sind bald wieder da.
        </p>
        <div className="mt-10 inline-flex items-center gap-2 text-sm text-slate-400">
          <Mail className="w-4 h-4 text-violet-300" />
          <a href="mailto:destek@mifelife.com" className="hover:text-white transition">destek@mifelife.com</a>
        </div>
      </div>
    </div>
  );
}
